// SessionStorage-backed cache for the catalogue list, so back-navigation from
// a series page restores the catalog instantly instead of refetching from
// scratch over a slow Indian mobile network. The cache is per-tab (session
// scope), persists across React route changes and SPA navigations, and gets
// wiped automatically when the tab closes — so we never serve a customer
// stale data more than a single session old.

const KEY = "sv_catalog_cache_v1";
const TTL_MS = 10 * 60 * 1000; // 10 minutes — long enough to cover a typical
                               // browse-then-tap-back cycle, short enough that
                               // admins editing prices propagate fast.

export function readCatalogCache() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    if (!parsed.ts || Date.now() - parsed.ts > TTL_MS) return null;
    if (!Array.isArray(parsed.series)) return null;
    return parsed; // { ts, series, bounds, params }
  } catch {
    return null;
  }
}

export function writeCatalogCache({ series, bounds, params }) {
  try {
    sessionStorage.setItem(
      KEY,
      JSON.stringify({ ts: Date.now(), series, bounds, params }),
    );
  } catch {
    // Quota errors — silently ignore. The catalog still works, just without
    // the instant-back-nav speedup.
  }
}

// Stable signature so we can tell whether the cached payload matches the
// filters the user is currently looking at.
export function paramsKey(params) {
  return JSON.stringify({
    q: params.q || "",
    category: params.category || "",
    available_only: !!params.available_only,
    price_min: params.price_min ?? null,
    price_max: params.price_max ?? null,
  });
}
